
export default {
  name: 'AddYourTeamSvg',
};
